import { SUB_CENTER, type SubCenterKey } from '@/constants/subCenter';

import { type JoinPrefixRoute, joinPrefix, mergeRouters } from '../util';

type RouteMode = 'data-center' | 'console';

const MODE_PREFIX: Record<RouteMode, string> = {
  'data-center': '/data-center/:cluster',
  console: '/console/:tenant/cluster/:cluster',
};

/** 将路由树按子中心路径段复制到指定模式前缀下 */
export function createSubCenterRoutes(
  routeGroups: JoinPrefixRoute[][],
  centerSegment: SubCenterKey,
  modes: RouteMode[],
): JoinPrefixRoute[] {
  const merged = mergeRouters(routeGroups);
  return modes.flatMap((mode) => joinPrefix(merged, [`${MODE_PREFIX[mode]}/${centerSegment}`]));
}

export { SUB_CENTER };
